import { format, parseISO, subDays } from 'date-fns';
import { FlightFragment, SegmentSearchParameter } from '@websky/graphql';
import { API_DATE_FORMAT } from '../../../utils';
import { SelectedFare } from '../../../DesktopFlight/types';

export const subsHalfCalendarDaysCount = (segment: SegmentSearchParameter, calendarDaysCount: number) => {
	const daysOffset = Math.floor(calendarDaysCount / 2);

	return {
		...segment,
		date: format(subDays(parseISO(segment.date), daysOffset), API_DATE_FORMAT)
	};
};

export const getSelectedFarePrice = (
	fare: SelectedFare,
	legIndex: number,
	useActualizedOrderFlightPrices: boolean,
	flightSegmentGroups?: FlightFragment['segmentGroups']
) => {
	const selectedPrice = fare.prices?.find(price => price.flight?.id === fare.flightInfo?.id);
	const actualizedSegmentGroup = flightSegmentGroups?.[legIndex];

	const price =
		useActualizedOrderFlightPrices && actualizedSegmentGroup?.price
			? actualizedSegmentGroup.price
			: selectedPrice?.price;

	return {
		price,
		priceInMiles: selectedPrice?.priceInMiles
	};
};
